<template>
  <div class="top5-dealer">
    <div class="top5-dealer__header">
      <span class="top5-dealer__title">Top 5 District</span>
    </div>
    <!-- <div class="top5-dealer__col-headers">
      <span class="top5-dealer__col">District</span>
      <span class="top5-dealer__col">Total Findings</span>
      <span class="top5-dealer__col"></span>
    </div> -->
    <div v-if="loading" class="top5-dealer__empty">Loading...</div>
    <template v-else>
      <div v-for="(item, idx) in dealers" :key="idx" class="top5-dealer__row" @click="$emit('detail', item)">
        <div class="top5-dealer__rank">{{ idx + 1 }}</div>

        <!-- <div class="top5-dealer__col d-flex align-items-center" style="gap: 5px;">
          <span class="top5-dealer__dot"></span>
          <span class="top5-dealer__district">{{ item.district || '-' }}</span>
        </div> -->

        <div class="top5-dealer__info">
          <span class="top5-dealer__district">{{ item.district || '-' }}</span>
          <span class="top5-dealer__region">{{ item.regency || '-' }}</span>
        </div>

        <!-- <span class="top5-dealer__col top5-dealer__findings">{{ item.totalFindings }}</span>
        <span class="top5-dealer__col top5-dealer__findings">
          <button class="top5-dealer__btn top5-dealer__btn--detail" @click="$emit('detail', item)">Detail</button>
        </span> -->

        <div class="top5-dealer__meta">
          <span class="top5-dealer__count">{{ item.totalFindings }}</span>
          <span class="top5-dealer__label">findings</span>
          <span class="top5-dealer__chevron">›</span>
        </div>
      </div>
      <div v-if="!dealers.length" class="top5-dealer__empty">No data</div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'DomainSummaryTop5Dealer',
  props: {
    startDate: { type: String, default: null },
    endDate: { type: String, default: null },
    province: { type: String, default: null },
    region: { type: String, default: null },
    district: { type: String, default: null },
  },
  data() {
    return {
      loading: false,
      dealers: [],
    }
  },
  watch: {
    startDate() { this.load() },
    endDate() { this.load() },
    province() { this.load() },
    region() { this.load() },
    district() { this.load() },
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.loading = true
      const params = {}
      if (this.startDate) params.start_date = this.startDate
      if (this.endDate) params.end_date = this.endDate
      if (this.province) params.province = this.province
      if (this.region) params.region = this.region
      if (this.district) params.district = this.district

      this.$http
        .get('/api/domain-detection-summary/top-5-district', { params })
        .then(resp => {
          const data = resp.data.data || []
          this.dealers = data.map(item => ({
            district: item.district,
            district_code: item.kode_kecamatan,
            regency: item.regency,
            region_code: item.kode_kotakab,
            province: item.province,
            kode_provinsi: item.kode_provinsi,
            totalFindings: item.total_findings,
          }))
        })
        .catch(err => {
          this.errorPrint(err)
          this.dealers = []
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style scoped>
.top5-dealer {
  background: #fff;
  border-radius: 16px;
  padding: 16px;
}

.top5-dealer__header {
  margin-bottom: 14px;
}

.top5-dealer__title {
  font-size: 13px;
  font-weight: 700;
  color: #2c2c2c;
}

.top5-dealer__row {
  display: flex;
  align-items: center;
  gap: 14px;
  background: #f4f5f7;
  border-radius: 14px;
  padding: 9px 10px;
  margin-bottom: 12px;
  cursor: pointer;
  transition: background 0.15s ease;
}

.top5-dealer__row:hover {
  background: #ececef;
}

.top5-dealer__row:last-child {
  margin-bottom: 0;
}

.top5-dealer__rank {
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #fff;
  border: 1px solid #dcdde1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  color: #6b6b6b;
}

.top5-dealer__info {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.top5-dealer__district {
  font-size: 12px;
  font-weight: 700;
  color: #1f1f1f;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.top5-dealer__region {
  font-size: 10px;
  color: #8a8a8a;
}

.top5-dealer__meta {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 6px;
}

.top5-dealer__count {
  font-size: 13px;
  font-weight: 700;
  color: #1f1f1f;
}

.top5-dealer__label {
  font-size: 10px;
  color: #9a9a9a;
}

.top5-dealer__chevron {
  font-size: 18px;
  color: #b5b5b5;
  margin-left: 4px;
}

.top5-dealer__empty {
  text-align: center;
  color: #9a9a9a;
  padding: 20px 0;
}
</style>
